<template>
  <div class="container is-fluid">
      <div class="columns">
        <div class="column" style="font-family: Helvetica">
          <section id="about-anchor" ref="about-anchor" class="hero">
            <div class="hero-body">
              <p class="title has-text-white">Sculptures</p>
              <p class="subtitle has-text-white">
                Sculptures articles
              <ul>
              <ul>
                <br />
                <li><router-link class="link" :to="{ name: 'SculpturesPdf' }">Catalogue</router-link></li>
                <li><router-link class="link" :to="{ name: 'SculpturesOtherCriticisms' }">Other criticisms</router-link></li>
                <li><li><router-link class="link" :to="{ name: 'SculpturesArticles' }">Articles</router-link></li>
                <li><a href="https://www.youtube.com/watch?v=qEPEwvc6gwk" target="_blank">Video</a></li>
                <li><a href="mailto:emanueleviscuso@gmail.com?subject=Price Request for sculptures" target="_blank" >Send Price Request</a></li>
              </ul>
              </ul>
              </p>
            </div>
          </section>
          <h2 class="abouttext">
            <h3>
              
<p class="article">Read the article "GADA"
	<a href="articles_pdf/gada.pdf" download="newfilename" target="_blank">
	<img src="articles_pdf/gada.JPG" width="175" height="250"  style="margin:10px 0 0 10px;" border="0"  />
	</a>
</p>

<p class="article">Read the article "GADA 2"
	<a href="articles_pdf/gada2.pdf" download="newfilename" target="_blank">
	<img src="articles_pdf/gada2.JPG" width="175" height="250"  style="margin:10px 0 0 10px;" border="0"  />
	</a>
</p>

<p class="article">Read the article "Lincoln Road Magazine"
	<a href="articles_pdf/lrm.pdf" download="newfilename" target="_blank">
	<img src="articles_pdf/lrm.JPG" width="175" height="250"  style="margin:10px 0 0 10px;" border="0"  />
	</a>
</p>

<p class="article">Read Various Articles
	<a href="articles_pdf/various.pdf" download="newfilename" target="_blank">
	<img src="articles_pdf/various.JPG" width="175" height="250"  style="margin:10px 0 0 10px;" border="0"  />
	</a>
</p>

<p class="article">Estado de Sao Paulo - POR
	<a href="articles_pdf/Estado de Sao Paulo.pdf" download="newfilename" target="_blank">
	<img src="articles_pdf/Estado de Sao Paulo.JPG" width="175" height="250"  style="margin:10px 0 0 10px;" border="0"  />
	</a>
</p>

<p class="article">Casa Y Estilo - SPA
	<a href="articles_pdf/Casa y Estilo Oct Nov 2001.pdf" download="newfilename" target="_blank">
	<img src="articles_pdf/Casa y Estilo Oct Nov 2001 pag 0.JPG" width="175" height="250"  style="margin:10px 0 0 10px;" border="0"  />
	</a>
</p>

<p class="article">La pasion de Frida en South Art Gallery - SPA
	<a href="articles_pdf/La pasion de Frida en South Art Gallery.pdf" download="newfilename" target="_blank">
	<img src="articles_pdf/null.jpg" width="175" height="250"  style="margin:10px 0 0 10px;" border="0"  />
	</a>
</p>

<p class="article">Diario Las Americas - Esp
	<a href="articles_pdf/esp/Diario Las Americas 1 9 86.JPG" download="newfilename" target="_blank">
	<img src="articles_pdf/esp/Diario Las Americas 1 9 86.JPG" width="175" height="250"  style="margin:10px 0 0 10px;" border="0"  />
	</a>
</p>

<p class="article">El Nuevo Herald 17 giugno 2001 - SPA
	<a href="articles_pdf/esp/El Nuevo Herald 17 giugno 2001.JPG" download="newfilename" target="_blank">
	<img src="articles_pdf/esp/El Nuevo Herald 17 giugno 2001.JPG" width="175" height="250"  style="margin:10px 0 0 10px;" border="0"  />
	</a>
</p>

<p class="article">FRIDAKAHLO EL HERALDO 23MARZO - 2 - SPA
	<a href="articles_pdf/esp/FRIDAKAHLO EL HERALDO 23MARZO 2.jpg" download="newfilename" target="_blank">
	<img src="articles_pdf/esp/FRIDAKAHLO EL HERALDO 23MARZO 2.jpg" width="175" height="250"  style="margin:10px 0 0 10px;" border="0"  />
	</a>
</p>

<p class="article">FRIDAKAHLO EL HERALDO 23MARZO - SPA
	<a href="articles_pdf/esp/FRIDAKAHLO EL HERALDO 23MARZO.jpg" download="newfilename" target="_blank">
	<img src="articles_pdf/esp/FRIDAKAHLO EL HERALDO 23MARZO.jpg" width="175" height="250"  style="margin:10px 0 0 10px;" border="0"  />
	</a>
</p>

<p class="article">FRIDAKAHLO LATRIBUNA 26 MARZO - ESP
	<a href="articles_pdf/esp/FRIDAKAHLO LATRIBUNA 26MARZO.JPG" download="newfilename" target="_blank">
	<img src="articles_pdf/esp/FRIDAKAHLO LATRIBUNA 26MARZO.JPG" width="175" height="250"  style="margin:10px 0 0 10px;" border="0"  />
	</a>
</p>

<p class="article">Miami Herald 22 8 86 - ESP
	<a href="articles_pdf/esp/Miami Herald 22 8 86.JPG" download="newfilename" target="_blank">
	<img src="articles_pdf/esp/Miami Herald 22 8 86.JPG" width="175" height="250"  style="margin:10px 0 0 10px;" border="0"  />
	</a>
</p>
</h3>
 </h2>
        </div>
        
        
      </div>
    </div>
</template>

<script>
export default {
  name: "SculpturesArticles",
  components: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #040303;
  background-attachment: fixed;
  background-size: cover;
  color: #fff;
}

.link {
  color: #9dc7de;
  transition: 0.3s color ease;

  &:hover {
    color: #e48353;
  }
}

a {
  color: #9dc7de;
  transition: 0.3s color ease;
}
a:hover {
  color: #e48353;
}
.article {
  align-content: center;
}
.bigimage {
  width: 80%;
}

.midimage {
  width: 50%;
}

.abouttext {
  font-family: "Helvetica";
  font-size: 1.8em;
  text-align: center;
}

h1 {
  margin-top: 2rem;
  z-index: 10;
  position: absolute;
}
</style>
